import { Event } from "../classes/Event";
import { utils } from "../../../../../shop/frontend/web/js/utils";
import {Modal} from "@shop/frontend/web/js/components/Modal";

/**
 *  Класс для страницы мероприятия
 * @extends Event
 */
export class EventPage extends Event {
	constructor() {
		super();
		this.$currentCount = $(".js-current-count");
		this.$svg = $("#js-svg");
		this.unit_id = this.$svg.data("unit");
		this.$svgElement = this.$svg.find("svg");
		this.$elements = this.$svgElement.find("g[mode]");
		this.$placeToSvg = $("#js-change-svg");
		this.$order = $(".js-order");
		this.eventId = this.$order.data("event");
		this.$buy = $("#js-order-button");
		this.$places = $("#js-places");
		this.$placesLegend = $("#js-places-legend");
		this.$placesCheckPrice = $("#js-places-check-price");
		this.$placesChoose = $("#js-places-choose");
		this.$placesInfo = $("#js-places-info");
		this.$placesChange = $("#js-places-change");
		this.$placesCost = $("#js-places-cost");
		this.$orderInfo = $("#js-order-info");
		this.$placesLimit = $("#js-places-limit");
		this.$placesBack = $("#js-places-back");
		this.$planZoomIn = $("#js-plan-zoom-in");
		this.$planZoomOut = $("#js-plan-zoom-out");
		this.$planZoomReset = $("#js-plan-zoom-reset");
		this.$tooltip = $("#js-tooltip-info");
		this.$prices = $(".js-places-prices");
		this.$popupModal = $("#js-popup-modal");
		this.$tickets = $("#js-tickets");
		this.$ticketsItems = $("#js-tickets-items");
		this.$stadium = $("#js-stadium");
		this.$stadiumPlan = this.$stadium.find(".threesixty");
		this.$stadiumPlace = $("#js-stadium-place");
		this.$mobileBuy = $(".js-mobile-buy");
		this.$bottom = $("#js-bottom");
		this.$pricesReset = $("#js-prices-reset");
		this.stadiumWidth = null;
		this.stadiumHeight = null;
		this.reverse = null;
		this.prices = window.prices;
		this.uniquePrices = window.uniquePrices;
		this.has_stadium_panorama = this.$stadium.length > 0;
		super.initFrontend();
	}

	init() {
		this.setIsSectorPlan();
		if (this.isDesktop.matches) {
			this.setSvgPlan();
			this.initTooltip();
		}
		this.setUpListenersCurrent();
		this.addActionToBack();

		if (this.isSectorPlan) {
			this.setTags();
			this.addActionToSector();
			if (!utils.getObjectFromSessionStorage("languages")) {
				//Проверка объекта languages в сессии
				this.getLanguages().then(res => {
					this.setPricesLabelToSector();
				});
			} else {
				this.setPricesLabelToSector();
			}
			this.addActionToPricesLabelToSector();
			this.$placesLegend.show();
			this.$placesChoose.hide();
			this.$places.addClass("active");
			if (this.has_stadium_panorama) {
				this.initStadium();
				this.addStadium();
			}
			this.setSectorsToStorage(); //загружает в хранилище минимальные по цене сектора
		} else {
			this.$placesInfo.removeClass("places__info_sector");
			if (this.isDesktop.matches) {
				this.setColors().then(() => {
					this.setPricesLabelToPlace();
					this.addActionToPricesLabelToPlace();
				});
			}
		}
		// if (this.isDesktop.matches) {
		// 	this.setTransformForTickets();
		// }
		this.addSliderToDates();
		this.backInHistory();
		this.modal = new Modal({className: "i-modal_alert"});
	}

	setUpListenersCurrent() {
		$(document).on("click", ".js-hide-additional-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".additional-info");
			$(parent).slideUp(300);
		});

		$(document).on("click", ".js-places-open", e => {
			const element = $(e.currentTarget);
			const promo = element.parents(".places").find(".js-promo");
			$(promo).show();
			element.toggleClass("active");
			$(".js-tickets").slideToggle("slow");
		});

		if (window.location.pathname.includes("event") && !this.isDesktop.matches) {
			this.getPopup();
		}

		this.$mobileBuy.on("click", () => {
			if (!this.isDesktop.matches) {
				this.getPopup();
			}
		});

		$(document).on("click", ".custom_previous", () => {
			if (this.reverse === "right") {
				this.stadium.previous();
			} else {
				this.stadium.next();
			}
		});

		$(document).on("click", ".custom_next", () => {
			if (this.reverse === "right") {
				this.stadium.next();
			} else {
				this.stadium.previous();
			}
		});

		$(document).on("click", "#js-stadium-prev", () => {
			if (this.reverse === "right") {
				this.stadium.previous();
			} else {
				this.stadium.next();
			}
		});

		$(document).on("click", "#js-stadium-next", () => {
			if (this.reverse === "right") {
				this.stadium.next();
			} else {
				this.stadium.previous();
			}
		});

		$(document).on("click", "#js-prices-reset", () => {
			$("input[data-zone]").removeClass("active");
			$(".js-svg g").removeClass("gray");
			$("#js-prices-reset").hide();
			$("input[data-zone]").each((i, item) => {
				item.checked = false;
				item.nextElementSibling.style.borderColor = "transparent";
			});
		});
	}

	setSectorsToStorage() {
		//set min price sectors to storage
		const sorted = this.prices.sort((a, b) => a.price - b.price);

		for (let i = 0; i < sorted.length; i++) {
			const minPrice = sorted[0].price;
			if (sorted[i].price === minPrice) {
				const viewId = sorted[i].viewId;
				const svgLocal = localStorage.getItem(`${this.unit_id}_${viewId}`);
				if (!svgLocal) {
					this.getSvg(viewId).then(res => {
						try {
							localStorage.setItem(`${this.unit_id}_${viewId}`, res.svg);
						} catch (e) {
							console.error(e);
						}
					});
				}
			}
		}
	}

	setAddToCart(sid) {
		this.addToCart(sid).then(res => {
			if (res.carts) {
				const place = $(`#${sid}`);
				if (!place.data("ispack")) {
					place.data("available", "false");
				}
				this.updateActiveSeat(sid, true);
				const parentElement = $(`.js-order[data-event="${this.eventId}"]`);
				const promo = parentElement.find(".js-promo");
				if (res.carts) {
					this.setTicketsItems(res.carts);
				}

				this.$currentCount.text(Number(this.$currentCount.text()) + 1);
				this.$eventSum.text(Number(this.$eventSum.text()) + res.carts[0].price);
				this.$sum.text(res.order.amount + res.order.commission);
				this.$orderInfo.show();
				promo.show();
				this.$placesLimit.show();
				this.$placesChange.addClass("short");
				this.$order.removeClass("short");
				this.$placesCost.addClass("show");
				this.$count.text(res.order.count_tickets);
				this.$bottom.addClass("active");
				const code = promo.data("promocode");

				if (code) {
					this.setPromocode(this.eventId, code);
				}

				if (!this.$buy.data("payment")) {
					this.$buy.data("payment", res.order.id);
					let type = "service";
					if (res.order.type_id === 0) {
						type = "event";
					}
					this.$buy.attr("href", `/pay/pay?id=${res.order.id}`);
					this.$buy.data("type", type);
				}
				this.setPlaceToStorage(sid, place);
			}

			if (res.redraw) {
				$(`#${sid}`).removeClass("active").addClass("default");
				this.modal.show("Данное место недоступно. Выберите другое.");
			}

			if (res.limit) {
				this.modal.show("Вы превысили максимально допустимое количество мест для брони");
			} else {
				for (let i = 0; i < res.carts.length; i++) {
					const item = res.carts[i];
					const isPack = res.carts[i].is_pack;
					if (!isPack) {
						$(`#${item.sid}`).addClass("in-cart");
					}
				}
				this.getCartCount(this.eventId);
			}
		});
	}

	insertDataToTicket(item, isPack) {
		let sector = "";
		let name = item.name;
		const sid = item.sid || item.id;
		const currentEventId = item.event_id;
		const isSectorContainsNumber = /[0-9]/.test(sector);

		if (item.sector) {
			name = name.replace(item.sector, "");
			sector = isSectorContainsNumber ? `${this.getWord("main", "Sector")}  ${item.sector}` : item.sector;
		}

		let price;

		if (item.price!==undefined) {
			price = item.price;
		} else {
			price = "";
		}
		return `<div class="tickets__item carousel-tickets__item js-ticket-template" data-event="${currentEventId}" data-place="${sid}" data-uid="${
			item.uid
		}" data-ispack="${isPack}">
					<div class="tickets__ticket-icon"><svg><use xlink:href="#ticket"></use></svg></div>
					<div class="tickets__content carousel-tickets__item-inner">
											<div class="tickets__sector">${sector}</div>

						<div class="tickets__place"><span class="js-ticket-place">${name}</span>
						<span class="tickets__place-price">
						<span class="js-ticket-price">${price}</span>
						${this.getWord("main", "$")}</span>
					</div>
					<div class="tickets__remove js-tickets-remove">
						<button class="reset-btn tickets__remove-button"  type="button" data-selenium="event_seat_delete">Удалить</button>
					</div>
					</div>
					</div>`;
	}

	initStadium() {
		let needStadium = true;
		let itFirst = true;
		let path;
		$(document).on("mouseover", e => {
			if (this.hasZoom) return;
			const element = $(e.target);
			if (element.closest("#svg").length || element.closest(".stadium").length) {
				if (this.isDesktop.matches) {
					const activeSector = $(element).closest("g[view_id]");
					if (activeSector.length) {
						let dataPath = activeSector.attr("path");
						if (itFirst) {
							this.initTreeSixty(dataPath);
							itFirst = false;
							path = dataPath;
						} else {
							if (dataPath === path) {
								needStadium = false;
							} else {
								needStadium = true;
								path = dataPath;
							}

							if (needStadium) {
								this.initTreeSixty(path);
							}
						}
						this.$stadium.addClass("active");
					}
				}
			} else {
				this.$stadium.removeClass("active");
			}
		});
	}

	initTreeSixty(path) {
		this.stadium = null;
		this.reverse = path;
		this.$stadiumPlan.stop();
		this.stadium = this.$stadiumPlan.ThreeSixty({
			totalFrames: 32, // Общее число кадров
			endFrame: 32, // конечный кадр
			currentFrame: 13, // с какого кадра стартовать
			imgList: ".threesixty_images", // селектор изображений
			progress: ".threesixty__spinner", // селектор элемента процесса загрузки
			imagePath: `/images/stadium/${path}/`, // путь к папке с изображениями
			filePrefix: "", // префикс файлов
			ext: ".jpg", // формат изображения
			height: this.stadiumHeight,
			width: this.stadiumWidth,
			navigation: false,
		});
	}

	addSliderToDates() {
		if (this.isDesktop.matches) {
			const datesSliderDom = document.querySelector("#js-swiper-dates");
			if (!datesSliderDom) {
				return false;
			}
			new Swiper(datesSliderDom, {
				navigation: {
					nextEl: datesSliderDom.parentNode.querySelector(".swiper-button-next"),
					prevEl: datesSliderDom.parentNode.querySelector(".swiper-button-prev"),
				},
				breakpoints: {
					768: {
						slidesPerView: 4,
					},
					880: {
						slidesPerView: 5,
					},
					1024: {
						slidesPerView: 6,
					},
				},
			});
		}
	}

	addActionToPricesLabelToPlace() {
		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			if (input.is(":checked")) {
				const color = input.data("color");
				input.next().css("border-color", color);
			}
			if ($(".places__price input:checked").length === 0) {
				$("g.active").removeClass("gray");
				return;
			}

			if ($(".places__price input:checked").length > 1) {
				this.$pricesReset.show();
			} else {
				this.$pricesReset.hide();
			}

			$("g.active").each((i, elem) => {
				const el = $(elem);
				const myPriceStr = String(el.data("zone"));
				if (myPriceStr) {
					const myPrice = myPriceStr.split(",");
					let hideFlag = 0;

					for (let j = 0; j < myPrice.length; j++) {
						if (!$(`input[data-zone="${parseInt(myPrice[j])}"]`).is(":checked")) {
							hideFlag++;
						}
					}
					if (hideFlag === myPrice.length) {
						el.addClass("gray");
					} else {
						el.removeClass("gray");
					}
				}
			});
		});
		$(".places__price").hover(
			e => {
				const color = $(e.currentTarget)
					.find(".places__price-color")
					.css("background-color");
				$(e.currentTarget).find(".places__price-content").css("border-color", color);
			},
			e => {
				const input = $(e.currentTarget).find("input");
				if (input.is(":checked")) {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", input.data("color"));
				} else {
					$(e.currentTarget).find(".places__price-content").removeAttr("style");
				}
			}
		);

		$(".places__price").on("click", e => {
			const element = $(e.currentTarget);
			if (element.find(".places__price-content").css("border-color") !== "transparent") {
				element.find(".places__price-content").css("border-color", "transparent");
			}

			if (!this.isDesktop.matches) {
				const input = element.find("input");
				if (input.is(":checked")) {
					input.removeAttr("checked");
				} else {
					input.attr("checked", "checked");
				}
				input.trigger("change");
			}
		});
	}

	backInHistory() {
		$("#js-back").on("click", e => {
			e.preventDefault();
			history.back();
		});
	}
}

const event = new EventPage();
event.init();
